import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import configWritingsEsCL from './locales/es-CL.json';
import configWritingsEnUS from './locales/en-US.json';
import configWritingsPtBR from './locales/pt-BR.json';

const configWritingsI18n = buildScopedI18n({
  esCL: configWritingsEsCL,
  enUS: configWritingsEnUS,
  ptBR: configWritingsPtBR,
});

export default configWritingsI18n;
